import { render, staticRenderFns } from "./PlayerRegistrationFormAddOnsCard.vue?vue&type=template&id=0c8995d0&scoped=true&"
import script from "./PlayerRegistrationFormAddOnsCard.vue?vue&type=script&lang=js&"
export * from "./PlayerRegistrationFormAddOnsCard.vue?vue&type=script&lang=js&"
import style0 from "./PlayerRegistrationFormAddOnsCard.vue?vue&type=style&index=0&id=0c8995d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8995d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
